import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio34 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15 18V19.5H9V18H15ZM16.5 16.5V7.5C16.5 6.67157 15.8284 6 15 6H9C8.17157 6 7.5 6.67157 7.5 7.5V16.5C7.5 17.3284 8.17157 18 9 18V19.5C7.39489 19.5 6.08421 18.2394 6.00391 16.6543L6 16.5V7.5C6 5.84315 7.34315 4.5 9 4.5H15C16.6569 4.5 18 5.84315 18 7.5V16.5C18 18.1569 16.6569 19.5 15 19.5V18C15.8284 18 16.5 17.3284 16.5 16.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio34);
export default ForwardRef;
